<template>
    <router-view></router-view>
</template>

<script>
export default {
    name: 'knowledge-layout',
};
</script>

<style></style>
